module.exports = __webpack_public_path__ + "img/light-logo-estadio-azteca.85886df6.png";